const css = `.vF4kWW__dayGrid{grid-template-columns:repeat(7,max-content);row-gap:6px;display:grid}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"dayGrid":"vF4kWW__dayGrid"};
